import axios from 'axios';

import {
    API_BASE_URL
} from '../../constants/index';

export default class KeywordManagementService {
    static instance;

    static getInstance() {
        if (!KeywordManagementService.instance) {
            KeywordManagementService.instance = new KeywordManagementService();
        }

        return KeywordManagementService.instance;
    }

    async fetchTagsList(params) {
        const response = await axios.get(`${API_BASE_URL}/news/tags_list`, {
            params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data?.data || [];
    }

    async fetchCategoriesList(params){
        const response = await axios.get(`${API_BASE_URL}/news/categories`, {
            params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data?.data || [];
    }

    async ceateTag(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/news/add_new_tag`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }

    async deleteTag(id){
        return await axios.delete(`${API_BASE_URL}/news/tag/${id}/remove`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        })
    }
}